import React from 'react'
import styled from 'styled-components/native'

import { CenteredTitle } from 'features/identityCheck/components/CenteredTitle'
import { analytics } from 'libs/analytics/provider'
import { env } from 'libs/environment/env'
import { SeparatorWithText } from 'ui/components/SeparatorWithText'
import { ExternalTouchableLink } from 'ui/components/touchableLink/ExternalTouchableLink'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Button } from 'ui/designSystem/Button/Button'
import { PageWithHeader } from 'ui/pages/PageWithHeader'
import { ExternalSiteFilled } from 'ui/svg/icons/ExternalSiteFilled'
import { IdCardWithMagnifyingGlass as InitialIdCardWithMagnifyingGlass } from 'ui/svg/icons/IdCardWithMagnifyingGlass'
import { Spacer, Typo } from 'ui/theme'

export const IdentityCheckDMS = () => {
  const onDMSFrenchCitizenPress = () => {
    analytics.logOpenDMSFrenchCitizenURL()
  }

  const onDMSForeignCitizenPress = () => {
    analytics.logOpenDMSForeignCitizenURL()
  }

  return (
    <PageWithHeader
      shouldLimitWidth
      title="Identification"
      scrollChildren={
        <Container>
          <StyledViewGap gap={5}>
            <IdCardWithMagnifyingGlass />
            <CenteredTitle title="Créer un dossier sur le site Démarche Numérique" />
            <StyledBody>
              La vérification de ton identité n’a pas pu aboutir. Tu peux créer un dossier sur le
              site Démarche Numérique afin d’obtenir ton pass Culture.
            </StyledBody>
          </StyledViewGap>
          <ButtonContainer>
            <ExternalTouchableLink
              as={Button}
              variant="tertiary"
              color="neutral"
              wording="Je suis de nationalité française"
              externalNav={{ url: env.DMS_FRENCH_CITIZEN_URL }}
              onBeforeNavigate={onDMSFrenchCitizenPress}
              icon={ExternalSiteFilled}
            />
            <CaptionNeutralInfo>Carte d’identité ou passeport.</CaptionNeutralInfo>
            <StyledSeparatorWithText>
              <SeparatorWithText label="ou" />
            </StyledSeparatorWithText>
            <ExternalTouchableLink
              as={Button}
              variant="tertiary"
              color="neutral"
              wording="Je suis de nationalité étrangère"
              externalNav={{ url: env.DMS_FOREIGN_CITIZEN_URL }}
              onBeforeNavigate={onDMSForeignCitizenPress}
              icon={ExternalSiteFilled}
            />
            <CaptionNeutralInfo>Titre de séjour, carte d’identité ou passeport.</CaptionNeutralInfo>
          </ButtonContainer>
          <Spacer.BottomScreen />
        </Container>
      }
    />
  )
}
const StyledViewGap = styled(ViewGap)(({ theme }) => ({
  alignItems: 'center',
  marginTop: theme.designSystem.size.spacing.xl,
}))

const IdCardWithMagnifyingGlass = styled(InitialIdCardWithMagnifyingGlass).attrs(({ theme }) => ({
  color: theme.designSystem.color.icon.brandPrimary,
  size: theme.illustrations.sizes.fullPage,
}))``

const Container = styled.View({ height: '100%', alignItems: 'center' })

const StyledBody = styled(Typo.Body)(({ theme }) => ({
  textAlign: 'center',
  color: theme.designSystem.color.text.subtle,
}))

const ButtonContainer = styled.View(({ theme }) => ({
  paddingVertical: theme.designSystem.size.spacing.xxxl,
}))

const StyledSeparatorWithText = styled.View(({ theme }) => ({
  marginVertical: theme.designSystem.size.spacing.xl,
}))

const CaptionNeutralInfo = styled(Typo.BodyAccentXs)(({ theme }) => ({
  textAlign: 'center',
  color: theme.designSystem.color.text.subtle,
}))
